export const SET_TIMER_CURRENT_ID = 'SET_TIMER_CURRENT_ID';
export const SET_TIMER_CURRENT_TIME = 'SET_TIMER_CURRENT_TIME';

export const SurveyTimerActions = {
    setCurrentId,
    setCurrentTime,
};

function setCurrentId(id: number | null) {
    return { type: SET_TIMER_CURRENT_ID, payload: id };
}

function setCurrentTime(time: number) {
    return { type: SET_TIMER_CURRENT_TIME, payload: time };
}
